import type { PendingUser, OkResponse } from '@/types/api';
import { apiFetch } from './client';

export function getPendingUsers(): Promise<PendingUser[]> {
  return apiFetch<PendingUser[]>('/api/admin/pending-users');
}

export function approveUser(userId: string): Promise<OkResponse> {
  return apiFetch<OkResponse>('/api/admin/approve-user', {
    method: 'POST',
    body: JSON.stringify({ user_id: userId }),
  });
}

export function rejectUser(userId: string): Promise<OkResponse> {
  return apiFetch<OkResponse>('/api/admin/reject-user', {
    method: 'POST',
    body: JSON.stringify({ user_id: userId }),
  });
}

export function addMember(data: Record<string, string>): Promise<OkResponse> {
  return apiFetch<OkResponse>('/api/admin/add-member', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function updateMember(
  originalName: string,
  fields: Record<string, string>,
): Promise<OkResponse> {
  return apiFetch<OkResponse>('/api/admin/update-member', {
    method: 'PATCH',
    body: JSON.stringify({ original_name: originalName, fields }),
  });
}
